import { setSessionStorageItem } from '../../sessionStorage/utils';
import { SESSION_STORAGE_LAST_SELECTED_DEPARTURE_FLIGHT } from '../../../utils/constants';

export default (selectedDepartureVar) => {
  return (newSelectedDeparture) => {
    selectedDepartureVar(newSelectedDeparture);
    setSessionStorageItem(SESSION_STORAGE_LAST_SELECTED_DEPARTURE_FLIGHT, newSelectedDeparture);
  };
};
